import { useState } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { StreamRecordingControls } from './stream-recording-controls';
import { StreamRecordingStatus } from './stream-recording-status';
import { StreamRecordingList } from './stream-recording-list';
import { StreamRecordingDownload } from './stream-recording-download';

interface StreamRecordingProps {
  streamId: number;
}

export function StreamRecording({ streamId }: StreamRecordingProps) {
  const [activeTab, setActiveTab] = useState('controls');

  return (
    <div className="space-y-6">
      {/* Status Overview */}
      <StreamRecordingStatus streamId={streamId} />

      {/* Main Tabs */}
      <Tabs value={activeTab} onValueChange={setActiveTab} className="space-y-4">
        <TabsList className="grid w-full grid-cols-4">
          <TabsTrigger value="controls">Controls</TabsTrigger>
          <TabsTrigger value="status">Status</TabsTrigger>
          <TabsTrigger value="list">Recordings</TabsTrigger>
          <TabsTrigger value="download">Download</TabsTrigger>
        </TabsList>

        <TabsContent value="controls">
          <StreamRecordingControls
            streamId={streamId}
            onStatusChange={() => {
              // Refresh status when controls change
              setActiveTab('status');
            }}
          />
        </TabsContent>

        <TabsContent value="status">
          <StreamRecordingStatus streamId={streamId} compact={false} />
        </TabsContent>

        <TabsContent value="list">
          <StreamRecordingList streamId={streamId} />
        </TabsContent>

        <TabsContent value="download">
          <StreamRecordingDownload
            streamId={streamId}
            onDownload={(recordingId) => {
              // Handle download completion
              console.log('Recording downloaded:', recordingId);
            }}
          />
        </TabsContent>
      </Tabs>
    </div>
  );
}
